'use client';

import { Link, Text, TextLevels } from '@bytel/trilogy-react';

export function FinePrint() {
    return (
        <Text level={TextLevels.FOUR}>
            *Réseau 5G : Déploiement progressif du réseau 5G (3,5 GHz et 2,1 GHz), principalement en zones urbaines avec
            offre et mobile compatibles 5G. Téléphones compatibles 5G et cartes de couverture sur{' '}
            <Link href='https://www.bouyguestelecom.fr/' blank>
                bouyguestelecom.fr
            </Link>
            .
        </Text>
    );
}
